module.exports = __webpack_public_path__ + "static/media/dec-thumb-help-large.ed034906.png";